export default "__VITE_ASSET__CDm8IDOF__"